import ReactECharts from 'echarts-for-react';
import { useState, useEffect } from "react";
import '../../../../cssfiles/homepage.css';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

export default function SankeyChart (props) {
  const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
  console.log("tagcollectionvalue at Sankey chart outside useEffect", tagcollectionvalue);

  const [sankeyoption, setSankeyOption] = useState({});
  const [linkage_collection_copy, setLinkage_collection_copy] = useState({});
  const [showNoData, setShowNoData] = useState(false);

  useEffect(() => {
    console.log("tagcollectionvalue at Sankey chart", tagcollectionvalue);
    const linkageObject = tagcollectionvalue["linkageObject"];
    setLinkage_collection_copy(linkageObject);

    if (linkageObject) {
      const hasNodeWithoutData = Object.values(linkageObject).some((node) => {
        const associatedValue = Number(node?.associated_value);
        return !Number.isFinite(associatedValue) || associatedValue === 0;
      });

      if (hasNodeWithoutData) {
        setShowNoData(true);
        setSankeyOption({});
        return;
      }

      setShowNoData(false);

      var tag_properties = props.widgetprop.props.extended.tagprops;
      var color_properties_sankey = [];
      const color_map = new Map();

      tag_properties.forEach(charttype => {
        color_properties_sankey.push(charttype.chartprops.color);
        color_map.set(charttype.tagid, charttype.chartprops.color);
      });

      const generateSankeyData = (linkage_collection_copy) => {
        const data = [];
        const links = [];

        const toNumericValue = (value) => {
          const numericValue = Number(value);
          return Number.isFinite(numericValue) ? numericValue : 0;
        };

        const allValues = Object.values(linkage_collection_copy).map((item) => toNumericValue(item?.associated_value));
        const allNodesAreZero = allValues.length > 0 && allValues.every((nodeValue) => nodeValue === 0);
        const minimumRenderValue = allNodesAreZero ? 1 : 0;

        // Create a set to track nodes to avoid duplicates
        const nodesSet = new Set();

        for (const [key, value] of Object.entries(linkage_collection_copy)) {
          const keyRawValue = toNumericValue(value.associated_value);
          const keyRenderValue = keyRawValue === 0 ? Math.max(keyRawValue, minimumRenderValue) : keyRawValue;

          // Add node data only if it is not already in the set
          if (!nodesSet.has(key)) {
            nodesSet.add(key);
            data.push({
              name: `${key}: ${keyRawValue.toFixed(2)} kWh`,
              value: keyRenderValue,
              rawValue: keyRawValue,
              itemStyle: {
                color: color_map.get(key),
                opacity: 1,
              },
            });
          }
          // Check if children are defined and process them
          if (Array.isArray(value.children)) {
            value.children.forEach(child => {
              const childValue = linkage_collection_copy[child];
              if (childValue) { // Ensure the child exists
                const childRawValue = toNumericValue(childValue.associated_value);
                const childRenderValue = childRawValue === 0 ? Math.max(childRawValue, minimumRenderValue) : childRawValue;

                // Add child node data if it is not already in the set
                if (!nodesSet.has(child)) {
                  nodesSet.add(child);
                  data.push({
                    name: `${child}: ${childRawValue.toFixed(2)} kWh`,
                    value: childRenderValue,
                    rawValue: childRawValue,
                    itemStyle: {
                      color: color_map.get(child),
                      opacity: 1,
                    },
                  });
                }

                // Create a link from parent to child
                links.push({
                  source: `${key}: ${keyRawValue.toFixed(2)} kWh`,
                  target: `${child}: ${childRawValue.toFixed(2)} kWh`,
                  value: childRenderValue,
                  rawValue: childRawValue,
                  lineStyle: {
                    opacity: 0.2,
                    curveness: 0.5,
                  }
                });
              }
            });
          }
        }

        return { data, links };
      };

      const { data, links } = generateSankeyData(linkageObject);
      const option = {
        tooltip: {
            backgroundColor: '#005C8E', // Transparent black background
            borderColor: '#005C8E',
            extraCssText: 'border-radius: 0 0 0 8px',
            formatter: (params) => {
              const tooltipRawValue = params?.data?.rawValue;
              const fallbackValue = Number(params?.value);
              const displayValue = Number.isFinite(tooltipRawValue) ? tooltipRawValue : (Number.isFinite(fallbackValue) ? fallbackValue : 0);
              return `${params.marker}${params.name}: ${displayValue.toFixed(2)} kWh`;
            },
            textStyle:{
              color:"#fff",
              fontSize: 12,
              height: 3,
              fontFamily: "Roboto",
              padding: 0
            }
        },
        series: [{
          type: 'sankey',
          layout: 'none',
          left: '2.5%',
          top: '8%',
          right: '10%',
          bottom: '1%',
          nodeWidth: 10,
          nodeGap: 13,
          nodeAlign: 'left',
          emphasis: {
            focus: 'adjacency'
          },
          data: data,
          links: links,
          lineStyle: {
              color: 'source',
              opacity: 0.2,
              curveness: 0.5,
          },
          label: {
            show: true,
            position: 'right',
            distance: 5,
            color: props.widgetprop.props.extended.label_color,
            fontWeight: props.widgetprop.props.extended.fontweight,
            fontSize: props.widgetprop.props.extended.fontsize,
            fontFamily: props.widgetprop.props.extended.fontfamily,
            align: 'left',
            borderWidth: 0,
          }
        }]
      };

      setSankeyOption(option);
    } else {
      setShowNoData(true);
      setSankeyOption({});
    }

  }, [props.widgetprop.widgetname, tagcollectionvalue]);

  if (showNoData) {
    return (
      <div style={{ height: '85%', width: '98%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontSize: 25, fontWeight: 400, color: '#0c0d0d' }}>
          No Data
        </Typography>
      </div>
    );
  }

  return (
    <ReactECharts
      option={sankeyoption}
      style={{ height: '85%', width: '98%' }}
    />
  );
}
